var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"animated fadeIn text-left text-white clearfix",attrs:{"to":_vm.to,"variant":"primary","block":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:`fal fa-${_vm.icon} mr-4 fa-2x float-left`}),_c('span',{staticClass:"float-left pt-1"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }